import {Button, Text} from "@mantine/core";
import { AccountCreateForm } from "./account.create.form";
import { useModals } from "@mantine/modals";
import { Plus } from "tabler-icons-react";

interface Props {
    onSubmitForm:(values:any) => void,
}

export function AccountCreateButton({ onSubmitForm }:Props) {
    const modals = useModals();

    async function _onSubmitForm(values:any){
        await onSubmitForm(values);
        modals.closeAll();
    }

    const renderAccountForm = () => {
        modals.openModal({
            withCloseButton:true,
            closeOnClickOutside:true,
            closeOnEscape:true,
            size:"900",
            overflow:'outside',
            title: (
                <Text size={'xl'}>Create New Account</Text>
            ),
            children: (
                <AccountCreateForm onSubmitQuery={_onSubmitForm}/>
            ),
        })
        return false;
    }

    return (
        <Button leftIcon={<Plus size={18}/>} onClick={renderAccountForm}>
            New Account
        </Button>
    )
}
